/**
 * CustomerPaymentCompleteScreen — Success or failure display
 */
import React, { useEffect } from 'react';

export default function CustomerPaymentCompleteScreen({ resultType, resultMessage, total, receiptData, onContinue, onDone, scheduleIdle }) {
  const approved = resultType === 'approved';
  const fmt = (n) => `$${Number(n).toFixed(2)}`;

  useEffect(() => {
    if (!approved && scheduleIdle) {
      scheduleIdle(6000);
    }
  }, [approved, scheduleIdle]);

  return (
    <div className="cfd-panel cfd-center cfd-slide-up" data-testid="complete-screen">
      <div className={`cfd-result-icon ${approved ? 'success' : 'fail'}`}>
        {approved ? (
          <svg viewBox="0 0 52 52" className="cfd-check-svg">
            <circle cx="26" cy="26" r="25" fill="none" stroke="currentColor" strokeWidth="3" className="cfd-check-circle" />
            <path fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" d="M14.1 27.2l7.1 7.2 16.7-16.8" className="cfd-check-path" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="cfd-x-svg">
            <circle cx="12" cy="12" r="10" /><path d="M15 9l-6 6M9 9l6 6" />
          </svg>
        )}
      </div>

      <h1 className={`cfd-result-title ${approved ? 'success' : 'fail'}`}>
        {approved ? 'Payment Approved!' : resultType === 'cancelled' ? 'Cancelled' : 'Payment Declined'}
      </h1>
      <p className="cfd-subtext">
        {resultMessage || (approved ? 'Thank you for your purchase!' : 'Please try again or ask for help.')}
      </p>

      {approved && <p className="cfd-total-display" style={{ marginTop: '0.5rem' }}>{fmt(total)}</p>}

      {receiptData && (
        <div className="cfd-receipt-info">
          {receiptData.card_type && receiptData.last_four && <p>{receiptData.card_type} ****{receiptData.last_four}</p>}
          {receiptData.auth_code && <p>Auth: {receiptData.auth_code}</p>}
        </div>
      )}

      {approved ? (
        <button onClick={onContinue} className="cfd-btn-primary" data-testid="continue-to-receipt-btn">
          Continue
        </button>
      ) : (
        <button onClick={onDone} className="cfd-btn-secondary" data-testid="back-to-idle-btn">
          Done
        </button>
      )}
    </div>
  );
}
